import React, { FC } from 'react';
import { Category } from 'api/timesheets/categories';
import { Form } from 'components/atoms/form';
import { Modal } from 'components/atoms/modal';
import { useTranslation } from 'hooks/use-translation';
import { Input } from './components';
import { useEditor } from './use-editor';

interface Props {
  editing: Category | null;
  setEditing: (next: Category | null) => void;
  onUpdate: (category: Category) => void;
}

export const Editor: FC<Props> = ({ editing, setEditing, onUpdate }) => {
  const { editorTitle, cancelEdit, handleEdit, okText, cancelText, id } =
    useEditor(onUpdate, editing, setEditing);

  return (
    <Modal
      visible={editing != null}
      title={editorTitle}
      confirmLoading={false}
      onCancel={cancelEdit}
      onOk={handleEdit}
      okText={okText}
      cancelText={cancelText}
      destroyOnClose
    >
      <Form layout="vertical">
        <Form.Item
          label={useTranslation(
            'settings.timesheets.controls.categories.edit.label',
          )}
        >
          <Input
            id={id}
            defaultValue={editing?.name}
            onPressEnter={handleEdit}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
